import { AxiosError } from 'axios'

export const strings = {
  unauthorized: 'نام کاربری یا رمز اشتباه است',
  username: 'نام کاربری',
  usernameOrNatinalCode: 'نام کاربری یا کد ملی',
  password: 'رمز',
  currentPassword: 'رمز فعلی',
  newPassword: 'رمز جدید',
  otpCode: 'یکبار رمز',
  sendOtp: 'ارسال یکبار رمز',
  role: 'نقش',
  fullname: 'نام کامل',
  nationalCode: 'کد ملی',
  phoneNumber: 'شماره موبایل',
  email: 'ایمیل',
  legalEntity: 'شرکت/سازمان',
  state: 'استان',
  city: 'شهر',
  groupName: 'گروه',
  groups: 'گروه ها',
  userGroups: 'گروه کاربر',
  mountpointGroups: 'گروه ایستگاه',
  accountInfo: 'اطلاعات کاربری',
  personalInfo: 'اطلاعات فردی',

  apply: 'اعمال',
  delete: 'حذف',
  changePassword: 'تغییر رمز',
  applying: 'در حال اعمال',
  done: 'انجام شد',
  yes: 'بلی',
  no: 'خیر',
  cancel: 'لغو',
  youSure: 'آیا مطمئن هستید؟',

  regular: 'معمولی',
  operator: 'اپراتور',
  admin: 'ادمین',
  error: 'خطا',
  mountpoint: 'ایستگاه',
  mainFields: 'فیلد های اصلی',
  ownerDisplayName: 'نام مالک',
  ownerPhoneNumber: 'شماره موبایل مالک',
  supplementaryFields: 'فیلد های تکمیلی',
  name: 'نام',
  latitude: 'عرض جغرافیایی',
  longitude: 'طول جغرافیایی',
  mountpointSource: 'منبع تصحیحات',
  mountpointSourceServer: 'ایستگاه ثابت',
  mountpointSourceNearest: 'نزدیک ترین',
  mountpointSourceExternal: 'کستر خارجی',
  creation: 'ایجاد',
  search: 'جستجو',
  notExists: 'وجود ندارد',
  search_create: 'جستجو / ایجاد',
  connectedTo: 'متصل به',
  sourceAgent: 'عامل منبع',
  IPAddr: 'آدرس آی پی',
  userAgent: 'مدل دستگاه',
  userAgentFilter: 'فیلتر مدل دستگاه',
  raymandAgent: 'رایمندی',
  nonRaymandAgent: 'غیر رایمندی',
  connectedTime: 'مدت اتصال',
  disconnectedTime: 'مدت قطعی',
  createdBy: 'ایجاد شده',
  seconds: 'ثانیه',
  empty: 'خالی',
  mountpointChartTitle: 'تعداد پیغام های تصحیحات',
  rtcmCount: 'تعداد RTCM',
  today: 'امروز',
  day: 'روز',
  week: 'هفته',
  month: 'ماه',
  allTime: 'کل',
  allData: 'نمایش کل داده‌ها',
  optional: 'اختیاری',
  captcha: 'کد امنیتی',
  confirmationCode: 'کد تایید',
  sourceType: 'نوع منبع',
  serverPassword: 'رمز سرور',
  sourceNearestNames: 'نام ایستگاه ها',
  sourceExternalAddr: 'آدرس کستر',
  sourceExternalUsername: 'نام کاربری کستر',
  sourceExternalPassword: 'رمز کستر',
  sourceExternalMountpoint: 'ایستگاه خارجی',
  identifier: 'نام منطقه',
  format: 'فرمت داده',
  formatDetails: 'محتوای داده',
  carrier: 'نوع سیگنال',
  navigationSystem: 'نوع سیستم',
  network: 'نام شبکه',
  country: 'کشور',
  nmea: 'نیاز به NMEA',
  solution: 'نوع تصحیحات',
  generator: 'تولید کننده تصحیحات',
  compressionEncryption: 'نوع رمزنگاری',
  authentication: 'احراز حویت',
  fee: 'هزینه',
  bitRate: 'نرخ بیت',
  miscellaneous: 'متفرقه',
  disconnected: 'قطع',
  optimal: 'مطلوب',
  acceptable: 'قابل قبول',
  weak: 'ضعیف',
  veryWeak: 'خیلی ضعیف',
  connected: 'متصل',
  disconnect: 'قطعی',
  showDisconnects: 'نمایش قطعی ها',
  yourTime: 'زمان شما',
  serverTime: 'زمان سرور',
  invalidTimeError:
    'زمان سیستم شما به درستی تنظیم نشده است و ممکن است برخی از اطلاعات به درستی نمایش داده نشود، لطفا برای استفاده بهتر از پنل زمان سیستم خود را به درستی تنظیم نمایید.',
  difference: 'اختلاف',
  goInPanel: 'ورود به پنل',
  noUserGroupMeansInactive:
    'کاربران بدون گروه غیر فعال هستند چون به هیچ چیزی دسترسی ندارند',
  active: 'فعال',
  inactive: 'غیر فعال',
  field: 'فیلد',
  fieldFilter: 'فیلتر فیلد',
  forgotPasswordChangeError: `در تغییر رمز خطایی پیش آمد، لطفا دوباره سعی کنید:`,
  deleteGroup: 'حذف گروه',
  renameGroup: 'تغییر نام گروه',
  distanceTool: 'ابزار فاصله',
  after: 'بعد از زمان',
  rowCount: 'تعداد سطر',
  serverFilter: 'فیلتر سرور',
  do: 'انجام',
  stationSettigns: 'تنظیمات ایستگاه',
  liveSignalsQualityGraph: 'گراف کیفیت لحظه ای سیگنال ها',
  satellitesCountGraph: 'گراف تعداد ماهواره ها',
  signalsQualityChangesGraph: 'گراف تغییرات کیفیت سیگنال ها',
  messagesCountGraph: 'گراف تعداد پیغام ها',
  from: 'از',
  to: 'تا',
  date: 'تاریخ',
  startDate: 'تاریخ شروع',
  endDate: 'تاریخ پایان',
  calendar: 'تقویم',
  perisanCalendar: 'شمسی',
  gregorianCalendar: 'میلادی',
  minute: 'دقیقه',
  hour: 'ساعت',
  averageRange: 'بازه متوسط گیری',
  unit: 'واحد',
  system: 'سیستم',
  displayGraph: 'نمایش گراف',
  distance: 'فاصله',
  dateRangeHelper: 'تاریخ شروع نمی تواند بزرگتر از تاریخ پایان باشد. ',
  users: 'کاربران',
  userSettings: 'تنظیمات کاربر',
  userStatus: 'وضعیت کاربر',
  mountpoints: 'ایستگاه ها',
  linksStabilityStatus: 'وضعیت پایداری لینک ها',
  groupsPermission: 'دسترسی گروه ها',
  measure: 'اندازه گیری فاصله',
  systemLog: 'لاگ سیستم',
  rinexService: 'سرویس راینکس',
  rinexRequest: 'درخواست راینکس',
  requestNewRinex: 'درخواست جدید راینکس',
  rinexRequestsList: 'لیست درخواست های راینکس',
  station: 'ایستگاه',
  startTime: 'ساعت شروع',
  endTime: 'ساعت پایان',
  range: 'بازه',
  dataRate: 'نرخ داده',
  rinexVersion: 'نسخه راینکس',
  applyRequest: 'ثبت درخواست',
  helperText: 'را وارد نمایید',
  selectHelperText: 'را انتخاب نمایید',
  projectName: 'نام پروژه',
  status: 'وضعیت',
  readyToDownload: 'آماده دانلود',
  processing: 'در حال پردازش',
  dataNotFound: 'داده ای یافت نشد!',
  systems: 'منظومه ها',
  unstable: 'ناپایدار',
  userHistory: 'تاریخچه کاربر',
  atLeastSelectOne: 'حداقل یک مورد را انتخاب نمایید',
  local: 'محلی',
  worldwide: 'جهانی',
  defaultName: 'نام پیش فرض',
  passwordMinLengthHelper: 'رمز عبور باید حداقل 8 کاراکتر باشد!',
  passwordFormatHelper:
    'رمز عبور میبایست متشکل از حروف بزرگ و کوچک انگلیسی، اعداد و علامت ها باشد!',
  withoutConnection: 'بدون ارتباط',
  yesterday: 'دیروز',
  dayBefore: 'روز پیش',
  altitude: 'ارتفاع',
  base: 'مرجع',
  confirmPosition: 'تایید موقعیت مرجع',
  coordinateDifference: 'اختلاف مختصات',
  useBasePosition: 'استفاده از موقعیت مرجع',
  start: 'شروع',
  end: 'پایان',
  logsList: 'لیست لاگ ها',
  diconnectionsList: 'لیست قطعی ها',
  connections: 'اتصالات',
  landingLoading: 'در حال انتقال به صفحه ورود...',
  analytics: 'تحلیل',
  uniqueDevices: 'گیرنده‌های یکتا',
  newDevices: 'گیرنده‌های جدید',
  returningDevices: 'گیرنده‌های قدیمی',
  uniqueRovers: 'روورهای یکتا',
  newRovers: 'روورهای جدید',
  returningRovers: 'روورهای قدیمی',
  hourly: 'ساعتی',
  daily: 'روزانه',
  weekly: 'هفتگی',
  monthly: 'ماهانه',
  loading: 'در حال بارگذاری...',
  growth: 'رشد',
  bases: 'بیس‌ها',
  devices: 'گیرنده‌ها',
  rovers: 'روورها',
  growthOfBases: 'رشد بیس‌ها',
  growthOfDevices: 'رشد گیرنده‌ها',
  growthOfBasesAndDevices: 'رشد گیرنده‌ها و بیس‌ها',
  growthOfRovers: 'رشد روورها',
  raymandRovers: 'روورهای رایمند',
  nonRaymandRovers: 'روورهای غیر رایمند',
  activeRaymandRovers: 'روورهای رایمند فعال',
  activeNonRaymandRovers: 'روورهای غیر رایمند فعال',
  allRaymandRovers: 'همه روورهای رایمند',
  allNonRaymandRovers: 'همه روورهای غیر رایمند',
  showAllRaymandRovers: 'نمایش روورهای رایمند',
  showAllNonRaymandRovers: 'نمایش روورهای غیر رایمند',
  lastAgent: 'آخرین ایجنت',
  otherAgents: 'سایر ایجنت‌ها',
  roverActivityHint:
    'در این نمودار، تعداد روورها به سه دسته نمایش داده می‌شود:\n\n' +
    'رایمندی: روورهایی که حداقل یک اتصال با user agent رایمندی داشته‌اند\n' +
    'غیر رایمندی: روورهایی که حداقل یک اتصال با user agent غیر رایمندی (و غیر خالی) داشته‌اند\n' +
    'Total: مجموع کل روورها\n' +
    '⚠️ توجه:\n' +
    'ممکن است یک روور همزمان در هر دو دسته رایمندی و غیر رایمندی شمارش شود، اگر در این بازه از هر دو نوع user agent استفاده کرده باشد.\n\n' +
    'به همین دلیل، مجموع رایمندی و غیر رایمندی ممکن است از مقدار Total بیشتر شود.\n ' +
    'همچنین، برخی روورها که user agent آن‌ها ثبت نشده (NULL) است، فقط در مقدار Total لحاظ می‌شوند و در هیچ‌یک از دو دسته دیگر قرار نمی‌گیرند.',
  cumulativeCount: 'تعداد تجمعی',
  newInBucket: 'جدید',
  last7Days: '۷ روز گذشته',
  last30Days: '۳۰ روز گذشته',
  last90Days: '۹۰ روز گذشته',
  noGrowthInRange: 'در بازه انتخاب‌شده داده‌ای ثبت نشده است',
  activity: 'فعالیت',
  dailyActivity: 'فعالیت روزانه',
  activeBases: 'بیس‌های فعال',
  activeDevices: 'گیرنده‌های فعال',
  activeBasesAndDevices: 'گیرنده‌ها و بیس‌های فعال',
  activeRovers: 'روورهای فعال',
  activeCount: 'تعداد فعال',
  noActivityInRange: 'در بازه انتخاب‌شده فعالیتی ثبت نشده است',
  close: 'بستن',
  serial: 'سریال',
  row: 'ردیف',
  baseConnections: 'اتصال بیس',
  roverConnections: 'اتصال روور',
  counterHintBasesActivity:
    'اتصال بیس: چند بار این بیس در همان روز آنلاین شده است',
  counterHintBasesGrowth:
    'اتصال بیس: چند بار این بیس در روز اول حضور خود در سامانه آنلاین شده است',
  counterHintBasesAll: 'اتصال بیس: کل دفعات آنلاین شدن این بیس',
  counterHintDevicesActivity:
    'اتصال روور: مجموع اتصال روورهایی که این گیرنده در همان روز سرویس داده است',
  counterHintDevicesGrowth:
    'اتصال روور: تعداد اتصال روور در روز اول حضور این گیرنده در سامانه',
  counterHintDevicesAll: 'اتصال روور: کل اتصال روورها از طریق این گیرنده',
  counterHintRoversActivity: 'اتصال روور: تعداد اتصال این روور در همان روز',
  counterHintRoversGrowth:
    'اتصال روور: تعداد اتصال این روور در روز اول حضور در سامانه',
  counterHintRoversAll: 'اتصال روور: کل اتصال این روور',
  allBases: 'همه بیس‌ها',
  allRovers: 'همه روورها',
  allDevices: 'همه گیرنده‌ها',
  allProvinces: 'همه استان‌ها',
  unknownProvince: 'خارج از ایران / نامشخص',
  growthByProvince: 'رشد به تفکیک استان',
  activityByProvince: 'فعالیت به تفکیک استان',
  growthOfBasesByProvince: 'رشد بیس‌ها به تفکیک استان',
  growthOfDevicesByProvince: 'رشد گیرنده‌ها به تفکیک استان',
  growthOfBasesAndDevicesByProvince: 'رشد گیرنده‌ها و بیس‌ها به تفکیک استان',
  growthOfRoversByProvince: 'رشد روورها به تفکیک استان',
  numberOfBasesByProvince: 'تعداد کل گیرندهای بیس به تفکیک استان',
  numberOfRoversByProvince: 'تعداد کل روورها به تفکیک استان',
  activeBasesByProvince: 'بیس‌های فعال به تفکیک استان',
  activeDevicesByProvince: 'گیرنده‌های فعال به تفکیک استان',
  activeRoversByProvince: 'روورهای فعال به تفکیک استان',
  activeBasesAndDevicesByProvince: 'گیرنده‌ها و بیس‌های فعال به تفکیک استان',
  cumulativeCountInRange: 'تعداد تجمعی در بازه',
  list: 'نمایش همه',
  showAllBases: 'نمایش همه بیس‌ها',
  showAllRovers: 'نمایش همه روورها',
  showAllDevices: 'نمایش همه گیرنده‌ها',
  exportCsv: 'خروجی CSV',
  events: 'رویدادها',
  eventType: 'نوع رویداد',
  eventTypes: 'انواع رویداد',
  allEvents: 'همه رویدادها',
  baseConnected: 'بیس متصل شد',
  baseDisconnected: 'بیس قطع شد',
  baseConnectFailed: 'اتصال بیس ناموفق',
  roverConnected: 'روور متصل شد',
  roverDisconnected: 'روور قطع شد',
  roverConnectFailed: 'اتصال روور ناموفق',
  searchEventsPlaceholder: 'جستجو در نام، نام کاربری، شماره موبایل یا ایستگاه',
  pageSize: 'تعداد در صفحه',
  all: 'همه',
  remoteIp: 'آی‌پی',
  disconnectCause: 'دلیل قطعی',
  duration: 'مدت',
  durationSeconds: 'مدت (ثانیه)',
  baseOwner: 'مالک بیس',
  noEventsInRange: 'در بازه انتخاب‌شده رویدادی ثبت نشده است',
  showing: 'نمایش',
  totalRecords: 'کل رکوردها',
  refresh: 'بازخوانی',
  clearFilters: 'حذف فیلترها',
  disconnectCauseHelp: 'راهنمای دلایل قطعی',
  disconnectCauseHelpTitle: 'معانی پیام‌های دلیل قطعی',
  disconnectCauseHelpBaseTitle: 'برای بیس',
  disconnectCauseHelpRoverTitle: 'برای روور',
  disconnectCauseConnectionResetBase:
    'connection reset by peer — بیس بدون اعلام قبلی اتصال TCP را قطع کرده است (بسته RST دریافت شده). معمولاً به‌دلیل قطع برق، کرش دستگاه، ریست NAT یا قطع ناگهانی شبکه رخ می‌دهد.',
  disconnectCauseIoTimeoutBase:
    'i/o timeout — در بازه‌ی timeout سرور هیچ داده‌ای از بیس دریافت/ارسال نشده است. معمولاً به‌دلیل قطع شبکه، هنگ کردن دستگاه، یا بسته شدن مسیر در میان (NAT/Firewall) رخ می‌دهد.',
  disconnectCauseEofBase:
    'EOF — بیس اتصال TCP را به‌صورت مرتب بسته است (FIN فرستاده). یعنی خاتمه طبیعی جلسه، بدون خطا.',
  disconnectCauseInvalidUserBase:
    'invalid user — نام کاربری یا رمز عبور بیس نامعتبر است یا کاربر اجازه‌ی اتصال به این ایستگاه را ندارد. اتصال در مرحله احراز هویت رد شده است.',
  disconnectCauseConnectionResetRover:
    'connection reset by peer — کلاینت NTRIP روور بدون اعلام قبلی اتصال را قطع کرده (RST دریافت شده). معمولاً به‌دلیل کرش اپلیکیشن، خاموش شدن دستگاه، یا قطع ناگهانی اینترنت موبایل رخ می‌دهد.',
  disconnectCauseIoTimeoutRover:
    'i/o timeout — روور در بازه‌ی timeout هیچ بسته‌ای (NMEA یا keep-alive) ارسال نکرده، پس اتصال قطع تلقی شده است. معمولاً به‌دلیل قطع شبکه یا کندی ارتباط رخ می‌دهد.',
  disconnectCauseEofRover:
    'EOF — کلاینت NTRIP روور اتصال را به‌صورت مرتب بسته است (logout/close معمولی)، یعنی خاتمه طبیعی جلسه.',
  disconnectCauseInvalidUserRover:
    'invalid user — نام کاربری یا رمز عبور روور نامعتبر است یا کاربر مجاز به اتصال به این ایستگاه نیست. اتصال در مرحله احراز هویت رد شده است.',
  viewList: 'لیست',
  viewMap: 'نقشه',
  noMapLocations: 'موقعیتی برای نمایش روی نقشه موجود نیست',

  topRovers: 'فعال‌ترین روورها',
  topRoversChartTitle: 'نمودار فعال‌ترین روورها',
  topRoversByConnections: 'بیشترین تعداد اتصال',
  topRoversByDuration: 'بیشترین مدت اتصال',
  topDevices: 'فعال‌ترین گیرنده‌ها',
  topDevicesChartTitle: 'نمودار فعال‌ترین گیرنده‌های بیس',
  topDevicesByConnections: 'بیشترین تعداد اتصال روور',
  topDevicesByDuration: 'بیشترین مدت اتصال روور',
  totalRoverConnections: 'تعداد اتصال روور',
  noTopDevicesInRange: 'در بازه انتخاب‌شده گیرنده فعالی یافت نشد',
  deviceActivityReport: 'گزارش فعالیت گیرنده',
  activityReport: 'گزارش فعالیت',
  basesCreated: 'بیس‌های ایجاد شده',
  mountpointsServed: 'montpoint‌های راه اندازی شده',
  mountpointVariant: 'ایستگاه (واریانت)',
  secretKey: 'Secret Key',
  roversConnectedTitle: 'روورهای متصل شده',
  user: 'کاربر',
  variant: 'واریانت',
  device: 'گیرنده',
  metric: 'معیار',
  totalConnections: 'تعداد اتصال',
  totalAirtime: 'مدت اتصال',
  totalRoverAirtime: 'مدت اتصال روور',
  airtime: 'مدت اتصال',
  durationHours: 'مدت (ساعت)',
  durationMinutes: 'مدت (دقیقه)',
  rover: 'روور',
  online: 'آنلاین',
  offline: 'آفلاین',
  roverActivityReport: 'گزارش فعالیت روور',
  basesConnectedToTitle: 'بیس‌های متصل شده',
  sessionsTitle: 'تاریخچه اتصالات',
  time: 'زمان',
  ongoing: 'در حال انجام',
  beforeWindow: 'قبل از بازه',
  connectionsCount: 'تعداد اتصال',
  maxDuration: 'بیشینه مدت',
  lastConnect: 'آخرین اتصال',
  noSessionsInRange: 'در بازه انتخاب‌شده اتصالی ثبت نشده است',
  noTopRoversInRange: 'در بازه انتخاب‌شده روور فعالی یافت نشد',

  // Hints used by the rover activity report dialog. Each describes the
  // semantics of one value/column so the operator can hover to learn what
  // they're looking at.
  hintRoverStatus:
    'وضعیت لحظه‌ای روور در زمان نمایش گزارش: آنلاین یعنی هم‌اکنون به یک بیس متصل است، آفلاین یعنی متصل نیست',
  hintRoverUsername: 'نام کاربری روور در سامانه',
  hintRoverPhone: 'شماره موبایل ثبت‌شده برای صاحب روور',
  hintRoverTotalConnections:
    'تعداد دفعاتی که این روور در بازه انتخاب‌شده به یک ایستگاه (بیس) متصل شده است',
  hintRoverTotalAirtime:
    'مجموع زمان آنلاین بودن روور در بازه (جمع مدت تمام اتصالات)',
  hintRoverMaxDuration: 'طولانی‌ترین مدت یک اتصال واحد در این بازه',
  hintRoverSessionsCount:
    'تعداد رکوردهای اتصال ثبت‌شده در بازه (هر اتصال یک ردیف در جدول پایین است)',
  hintBaseConnectionsCount:
    'تعداد دفعاتی که این روور به این ایستگاه متصل شده است',
  hintBaseTotalAirtime: 'مجموع زمان اتصال این روور به این ایستگاه',
  hintBaseMaxDuration: 'طولانی‌ترین مدت یک اتصال واحد به این ایستگاه',
  hintBaseLastConnect: 'آخرین تاریخ و ساعت اتصال روور به این ایستگاه',
  hintSessionRow: 'شماره ترتیبی ردیف',
  hintSessionMountpoint: 'ایستگاهی که روور در این اتصال به آن متصل بوده است',
  hintSessionDate:
    'تاریخ آغاز اتصال. اگر اتصال پیش از شروع بازه آغاز شده باشد، «قبل از بازه» نمایش داده می‌شود',
  hintSessionStart:
    'ساعت آغاز اتصال. برای اتصال‌هایی که قبل از بازه شروع شده‌اند نمایش داده نمی‌شود',
  hintSessionEnd:
    'ساعت پایان اتصال. اگر روور هم‌اکنون آنلاین است «در حال انجام» نمایش داده می‌شود',
  hintSessionDuration:
    'مدت این اتصال. برای اتصال‌های در حال انجام، با گذر زمان به‌روزرسانی می‌شود',
  hintRowOngoing: 'سطر سبز: اتصال هنوز قطع نشده و در حال انجام است',
  hintRowTruncated:
    'سطر زرد: اتصال پیش از شروع بازه آغاز شده است؛ ساعت شروع در دسترس نیست',

  // Strings used by the daily-activity section of the rover report dialog.
  dailyActivityTitle: 'فعالیت روزانه روور',
  hintDailyActivity:
    'هر سطر یک روز از بازه‌ی انتخاب‌شده است و هر خانه یک ساعت از آن روز. تیرگی رنگ خانه نشان‌دهنده‌ی مدت اتصال روور در آن ساعت است. با عبور موس روی هر خانه، جزئیات ساعت و مدت اتصال نمایش داده می‌شود.',
  activeDays: 'روزهای فعال',
  hintActiveDays:
    'تعداد روزهایی که در آن‌ها حداقل یک اتصال ثبت شده است (از مجموع روزهای بازه)',
  longestStreak: 'طولانی‌ترین رشته فعال',
  hintLongestStreak:
    'بیشترین تعداد روزهای متوالی فعال در بازه (روزهایی که در همه‌ی آن‌ها حداقل یک اتصال ثبت شده است)',
  noActivityDay: 'اتصالی ثبت نشده',
  peakHourTitle: 'الگوی ساعتی اتصال',
  hintPeakHourStrip:
    'این نمودار، توزیع تعداد اتصال‌های روور را در ساعت‌های مختلف شبانه‌روز در کل بازه‌ی انتخاب‌شده نشان می‌دهد. ساعت اوج، ساعتی است که بیشترین تعداد اتصال در آن ثبت شده است.',
  peakHourLabel: 'اوج اتصال در ساعت',
  connectionUnit: 'اتصال',

  // Hints used by the device activity report dialog.
  hintDeviceOwner: 'نام مالک ثبت‌شده‌ی این گیرنده',
  hintDeviceOwnerPhone: 'شماره موبایل مالک گیرنده',
  hintDeviceBasesCreated:
    'تعداد بیس‌هایی که با این گیرنده در سامانه ایجاد شده‌اند',
  hintDeviceMountpointsServed:
    'تعداد ایستگاه‌های متمایزی که این گیرنده در بازه به آن‌ها سرویس داده است (تعداد واریانت‌ها)',
  hintDeviceTotalRoverConnections:
    'مجموع تعداد دفعاتی که روورها از طریق این گیرنده در بازه متصل شده‌اند',
  hintDeviceRoversCount:
    'تعداد روورهای متمایزی که در بازه از طریق این گیرنده متصل شده‌اند',
  hintDeviceTotalRoverAirtime:
    'مجموع مدت زمان اتصال همه روورها از طریق این گیرنده در بازه',
  hintDeviceSessionsCount:
    'تعداد رکوردهای اتصال ثبت‌شده برای این گیرنده در بازه (هر اتصال یک ردیف در جدول پایین است)',
  hintMountpointVariant:
    'مدل یا واریانتی که گیرنده برای این ایستگاه ارائه می‌دهد',
  hintMountpointSecretKey:
    'کلید مخفی این ایستگاه که برای احراز هویت اتصال‌ها استفاده می‌شود',
  hintMountpointCreator: 'کاربری که این ایستگاه را در سامانه ایجاد کرده است',
  hintMountpointRoverConnections:
    'تعداد اتصال روور به این ایستگاه از طریق این گیرنده در بازه',
  hintRoverCardConnections:
    'تعداد دفعاتی که این روور از طریق این گیرنده متصل شده است',
  hintRoverCardTotalAirtime: 'مجموع زمان اتصال این روور از طریق این گیرنده',
  hintRoverCardMaxDuration:
    'طولانی‌ترین مدت یک اتصال واحد این روور از طریق این گیرنده',
  hintRoverCardLastConnect:
    'آخرین تاریخ و ساعت اتصال این روور از طریق این گیرنده',
  hintDeviceSessionUser:
    'کاربری که در این اتصال از طریق گیرنده آنلاین بوده است',
  hintDeviceSessionUsername: 'نام کاربری روور در این اتصال',
  hintDeviceSessionVariant:
    'ایستگاه (واریانت) گیرنده که روور در این اتصال از آن استفاده کرده است',

  mapAxiosError: (err: AxiosError): AxiosError => {
    if (!err.response) {
      err.message = 'پاسخی دریافت نشد'
      return err
    }

    if (err.response.status === 500) {
      err.message = 'خطای سرور'
      return err
    }

    if (err.response.status === 403) {
      err.message = 'خطای دسترسی'
      return err
    }

    if (err.response.status === 429) {
      err.message = 'تعداد درخواست بیش از حد مجاز'
      return err
    }

    let errCode: number
    try {
      errCode = parseInt(err.response.data.split('\n')[0].split(':')[1])
    } catch (e) {
      err.message = 'خطای ناشناخته'
      return err
    }

    switch (errCode) {
      case -1:
        err.message = 'مشکلی در اجرای درخواست پیش آمد'
        return err
      case 1:
        err.message = 'محتوی درخواست نادرست است'
        return err
      case 2:
        err.message = 'کد یکبار مصرف اشتباه است'
        return err
      case 3:
        err.message = 'نام کاربری قابل قبول نیست'
        return err
      case 4:
        err.message = 'نقش کاربر اشتباه است'
        return err
      case 5:
        err.message = 'کد ملی اشتباه است'
        return err
      case 6:
        err.message = 'رمز عبور قابل قبول نیست'
        return err
      case 7:
        err.message = 'نام کاربری وجود دارد'
        return err
      case 8:
        err.message = 'رمز عبور قبلا استفاده شده است'
        return err
      case 9:
        err.message = 'نام کاربری/رمز عبور اشتباه است'
        return err
      case 10:
        err.message = 'نام گروه قابل قبول نیست'
        return err
      case 11:
        err.message = 'نام مانت پوینت قابل قبول نیست'
        return err
      case 12:
        err.message = 'نوع منبع داده اشتباه است'
        return err
      case 13:
        err.message = 'کد امنیتی اشتباه است'
        return err
      default:
        err.message = 'خطای ناشناخته'
        return err
    }
  },
}
